import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Self-hosted fonts (replaces Google Fonts preload). Loaded via @fontsource
// so the @font-face declarations are bundled by Vite — no third-party
// requests, no ePrivacy / Munich-ruling exposure.
import '@fontsource/ubuntu/400.css'
import '@fontsource/ubuntu/500.css'
import '@fontsource/ubuntu/700.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'

import './global.css'
import { ThemeProvider } from './contexts/ThemeContext'
import Playground from './Playground'

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <ThemeProvider>
            <Playground />
        </ThemeProvider>
    </StrictMode>,
)
